export default {
  DELETED_MSG: 'message supprimé',
  ADD_MEMBERS: 'Ajouter des membres',
  DEL_MEMBERS: 'Supprimer des membres',
  DEL_GROUP_CHAT: 'Supprimer la discussion',
  SEARCH_BY_NAME: 'Rechercher par nom...',
  START_SEARCH_BY_USER_NAME: "Commencez une recherche d'utilisateur par nom...",
  GROUP_CHAT: 'Discussion',
  CHANGE_ADMIN: "Changer l'Admin",
  PROMPT_DEL_ROOM: 'Êtes-vous sûr de vouloir supprimer cette discussion une fois pour toutes ?',
  USER_ACTIVE: 'Actif',
  USER_INACTIVE: 'Inactif',
  SEND: 'Envoyer',
  DOWNLOAD_FILE: 'Télécharger le fichier',
  // The refreshed assistant shell localizes navigation, actions, composer guidance, and modal copy.
  ASSISTANT_EYEBROW: 'Assistant IA',
  ASSISTANT_SELECTOR: 'Choisir un assistant',
  ALERTS: 'Notifications et actions planifiées',
  CONTACT_EXPERT: 'Contacter un expert',
  YOU: 'Vous',
  QUICK_ACTIONS: 'Actions rapides',
  MORE_ACTIONS: 'Plus d’actions',
  ACTIONS_MODAL_TITLE: 'Que souhaitez-vous faire ?',
  ACTIONS_MODAL_DESCRIPTION: 'Choisissez une action, puis adaptez la demande préparée avant de l’envoyer.',
  ACTIONS_EMPTY_TITLE: 'Aucune action disponible',
  ACTIONS_EMPTY_DESCRIPTION: 'Emye proposera des actions contextuelles au fil de la conversation.',
  COMPOSER_LABEL: 'Message à l’assistant',
  COMPOSER_PLACEHOLDER: 'Décrivez votre besoin ou choisissez une action suggérée…',
  ATTACH_FILE: 'Joindre un fichier',
  SEND_MESSAGE: 'Envoyer le message',
  PROCESSING: 'Emye prépare la réponse',
  AI_DISCLAIMER: 'Les assistants IA peuvent se tromper. Vérifiez les informations importantes avant de les utiliser.',
  SUGGESTIONS_LOAD_ERROR: 'Impossible de charger les actions rapides.',
  // Historical generated files remain listed after their temporary workspace artifact expires.
  GENERATED_FILE_UNAVAILABLE: "Ce document a expiré ou n'est plus disponible.",
  // Structured interaction chrome is localized while model-authored prompts remain plain response text.
  INTERACTION_QUESTION_PROGRESS: 'Question {{current}} sur {{total}}',
  INTERACTION_OTHER: 'Autre',
  INTERACTION_OTHER_PLACEHOLDER: 'Précisez votre réponse',
  INTERACTION_TEXT_PLACEHOLDER: 'Saisissez votre réponse',
  INTERACTION_PREVIOUS: 'Précédent',
  INTERACTION_CONTINUE: 'Continuer',
  INTERACTION_SEND_ANSWERS: 'Envoyer les réponses',
  INTERACTION_ANSWERED: 'Répondu',
  INTERACTION_FREE_ANSWER: 'Réponse libre',
  INTERACTION_FOLLOW_UP_TITLE: 'Actions suggérées',
  INTERACTION_SINGLE_SELECT_HINT: 'Choisissez une option pour continuer.',
  INTERACTION_MULTI_SELECT_HINT: 'Choisissez une ou plusieurs options, puis continuez.',
  INTERACTION_INVALID: 'Ces réponses ne sont pas valides. Veuillez réessayer.',
  INTERACTION_STALE: "Cette question n'est plus active. La conversation a été actualisée.",
  // L'interface du workflow est traduite localement; Emye fournit les titres et résumés dans la langue choisie.
  WORKFLOW_TITLE: 'Plan de traitement',
  WORKFLOW_PROGRESS: 'Progression de la demande complexe',
  WORKFLOW_BUILDING_PLAN: 'Préparation d’un plan fiable',
  WORKFLOW_PHASE_PLANNING: 'Planification des étapes',
  WORKFLOW_PHASE_EXECUTING: 'Exécution du plan',
  WORKFLOW_PHASE_FINALIZING: 'Vérification du résultat final',
  WORKFLOW_STEP_PENDING: 'En attente',
  WORKFLOW_STEP_IN_PROGRESS: 'En cours',
  WORKFLOW_STEP_COMPLETED: 'Terminée et vérifiée',
  WORKFLOW_STEP_FAILED: 'Vérification impossible',
}
